import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GeneralService } from './general.service';
import { HttpClient } from '@angular/common/http';
import { QuotationContractDates } from '../models/maintenance/migration-maintenance.model';

@Injectable({
  providedIn: 'root',
})
export class MigrationMaintenanceService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public GetQuotationContractDates(
    idCotizacion: string | number,
  ): Observable<QuotationContractDates | null> {
    return this.http
      .get<QuotationContractDates>(this.URL_API + '/GetQuotationContractDates/' + idCotizacion, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public quotationContractDates(body: {
    fechaInicio: string;
    idCotizacion: number;
    plazo: number;
  }): Observable<QuotationContractDates | null> {
    return this.http
      .patch<QuotationContractDates>(this.URL_API + '/quotation-contract-dates', body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
